module.exports = __webpack_public_path__ + "static/car-1bd4bf6350964ea4a909d354432488b8.jpeg";